import { render } from "./TemplateEditComponent.vue?vue&type=template&id=9ba69fd8&scoped=true"
import script from "./TemplateEditComponent.vue?vue&type=script&lang=js"
export * from "./TemplateEditComponent.vue?vue&type=script&lang=js"

import "./TemplateEditComponent.vue?vue&type=style&index=0&id=9ba69fd8&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba69fd8"]])

export default __exports__